import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchTrigger'

export default defineMessages({
  searchAriaLabel: {
    id: `${scope}.searchAriaLabel`,
    defaultMessage: 'Search. Press {shortcutLabel} to open',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search',
  },
})
